import React, { useState } from "react";
import "./menuItem.css";
import TestImage from "../../../images/test-image.png";
import ShoppingCartIcon from "../../../images/icons/shopping-cart.png";
import MultiMenuItem from "../MultiMenuItem/MultiMenuItem";

import { useOrder } from "../../../contexts/OrderContext";
import { toast } from "react-toastify";

import { useAuth } from "../../../contexts/AuthContext";

export default function MenuItem({ data, remainConsistant }) {
  const {
    addToCart,
    isInCart,
    increaseQuantity,
    decreaseQuantity,
    isInProcess,
  } = useOrder();

  const { currentUser } = useAuth();

  const [isModalOpen, setIsModalOpen] = useState(false);

  const dropZeros = (price) => parseInt(price) / 1000;

  const [isIn, quantity, multiMode] = isInCart(data.ProductId);

  const allowEdit = !isInProcess();

  function handlePurchase() {
    if (isIn) return;
    if (!currentUser)
      return toast.info("جهت تغییر در سبد خرید ابتدا وارد شوید");
    if (!allowEdit) return toast.info("سفارش ثبت شده قابل تغییر نمی باشد");
    if (data.ProductMultiPriceMode !== "0") return setIsModalOpen(true);

    const item = {
      ProductID: data.ProductId,
      Quantity: 1,
      ProductMultiMode: "false",
      ProductTitle: data.ProductTitle,
      ProductPicture: data.ProductPictureUrl,
      Price: data.ProductPrice,
      PriceAfterDiscount: data.ProductPriceAfterDiscount,
    };

    addToCart(item);
  }

  function handleIncrease() {
    increaseQuantity(data.ProductId);
  }

  function handleDecrease() {
    if (quantity === 1) return;
    decreaseQuantity(data.ProductId);
  }

  return (
    <>
      <div
        className={`menu-item ${isIn ? "menu-item-added" : ""}`}
        style={data.Quantity === 0 ? { filter: "saturate(0)" } : {}}
      >
        {data.HasDiscount && (
          <div className="discount-badge">
            %<span className="discount-num">{data.DiscountPercent}</span>
          </div>
        )}
        <img src={data.ProductPictureUrl} alt="" className="item-photo" />
        <div className="item-text">
          <h3 className="item-name">{data.ProductTitle}</h3>
          <p className="item-description">{data.ProductDescription}</p>
          {data.Quantity === 0 ? (
            <div className="item-price">ناموجود</div>
          ) : (
            <div className="item-price">
              {data.ProductMultiPriceMode !== "0" && (
                <span className="price-multi-mode">از</span>
              )}
              {data.HasDiscount && (
                <s className="price-discount">{dropZeros(data.ProductPrice)}</s>
              )}
              <span className="price-number">
                {dropZeros(data.ProductPriceAfterDiscount)}
              </span>
              هزار تومان
            </div>
          )}
        </div>

        {data.ProductMultiPriceMode === "0" ? (
          <div className="amount">
            {allowEdit && (
              <span className="amount-minus" onClick={handleDecrease}>
                -
              </span>
            )}
            {quantity}
            {allowEdit && (
              <span className="amount-add" onClick={handleIncrease}>
                +
              </span>
            )}
          </div>
        ) : (
          <div
            className="amount edit-multi"
            onClick={() => (allowEdit ? setIsModalOpen(true) : null)}
          >
            ویرایش
          </div>
        )}
        {data.Quantity !== 0 && (
          <div className="add-to-list" onClick={handlePurchase}>
            <img src={ShoppingCartIcon} alt="" />
          </div>
        )}

        {data.ProductMultiPriceMode !== "0" && allowEdit && (
          <MultiMenuItem
            open={isModalOpen}
            onClose={() => setIsModalOpen(false)}
            data={data}
            dropZeros={dropZeros}
            multiMode={multiMode}
          />
        )}
      </div>
    </>
  );
}
